
const UUID = require('uuid-js');

const { JSableOmitPrivateMixin } = require('jsable');

const IdentifiedMixin = (superclass, jsableSuperclassMixin) => {
	jsableSuperclassMixin = jsableSuperclassMixin || JSableOmitPrivateMixin;

	if (!superclass.prototype.toJS) {
		superclass = jsableSuperclassMixin(superclass);
	}

	return class Identified extends superclass {
		constructor (...args) {
			super(...args);

			this.ID = UUID.create().hex;
		}

		toJS (...args) {
			const js = super.toJS(...args);
			js.ID = this.ID;
			return js;
		}
	};
};

const Identified = IdentifiedMixin(class {});

module.exports = {
	IdentifiedMixin,
	Identified,
};
